import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, GuardResult, RouterStateSnapshot } from "@angular/router";

import { firstValueFrom, map } from "rxjs";

import { NodeId } from "#src/core/backend/controllers";

import { LibraryNavigationService } from "#modules/library/services/library-navigation.service";
import { ContentCheckerService } from "#modules/shared";

import { LinkInterceptor } from "../services/link-interceptor.service";

export const nodeRedirectGuard: CanActivateFn | CanActivateChildFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<GuardResult> => {
  const libraryNavigationService = inject(LibraryNavigationService);
  const contentCheckerService = inject(ContentCheckerService);
  const linkInterceptor = inject(LinkInterceptor);
  const nodeId: NodeId | undefined = route.params.nodeId;
  if (!nodeId) return true;

  const content = (await firstValueFrom(libraryNavigationService.getPathInfo({ nodeId })).catch(() => null))?.contentNode?.content;
  if (!content) return true;

  const contentType = contentCheckerService.getContentType(content);
  if (contentType.type !== "link") return true;

  return firstValueFrom(linkInterceptor.maybeRedirect(contentType).pipe(map(() => false))).catch(() => false);
};
